import script from "./pdf-viewer-toggle.vue?vue&type=script&setup=true&lang=ts"
export * from "./pdf-viewer-toggle.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__